import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

const FAV_KEY = "casamore_preferiti";

export function AppProvider({ children }) {
  const [favorites, setFavorites] = useState([]);
  const [compare, setCompare] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(FAV_KEY);
      if (raw) setFavorites(JSON.parse(raw));
    } catch (e) {
      console.error("Preferiti: lettura da localStorage fallita", e);
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(FAV_KEY, JSON.stringify(favorites));
    } catch (e) {
      console.error("Preferiti: salvataggio in localStorage fallito", e);
    }
  }, [favorites]);

  const toggleFavorite = useCallback((id) => {
    setFavorites((prev) => {
      const has = prev.includes(id);
      toast[has ? "message" : "success"](has ? "Rimosso dai preferiti" : "Aggiunto ai preferiti");
      return has ? prev.filter((x) => x !== id) : [...prev, id];
    });
  }, []);

  const toggleCompare = useCallback((id) => {
    setCompare((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= 3) {
        toast.error("Puoi confrontare al massimo 3 immobili.");
        return prev;
      }
      return [...prev, id];
    });
  }, []);

  const clearCompare = useCallback(() => setCompare([]), []);

  return (
    <AppCtx.Provider
      value={{ favorites, toggleFavorite, compare, toggleCompare, clearCompare }}
    >
      {children}
    </AppCtx.Provider>
  );
}
